import * as React from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router'
import CreateOrganization from '../../containers/organizations/CreateOrganization'
import EditOrganization from '../../containers/organizations/EditOrganizationPane'
import Organizations from '../../containers/organizations/Organizations'
import ViewOrg from '../../containers/organizations/ViewOrg'
import ErrorBoundary from '../ErrorBoundary'

const OrganizationsPane = (props: RouteComponentProps<any>) => {
  return (
    <ErrorBoundary>
      <Switch>
        <Route path={`${props.match.path}`} exact={true} component={Organizations} />
        <Route path={`${props.match.path}/create`} component={CreateOrganization} />
        <Route exact={true} path={`${props.match.path}/:id`} component={ViewOrg} />
        <Route path={`${props.match.path}/:id/edit`} component={EditOrganization} />
      </Switch>
    </ErrorBoundary>
  )
}

export default OrganizationsPane



// WEBPACK FOOTER //
// ./src/components/organizations/OrganizationsPane.tsx